import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';

import { FundsRoutingGraph } from "../graph/FundsRoutingGraph";
import { StatusLegend } from "../StatusLegend";
import { EscrowWalletCard } from "./EscrowWalletCard";
import { ScWalletCard } from "./ScWalletCard";
import { TransferFlowDocsAccordion } from "./TransferFlowDocsAccordion";

type OperatorDetailsViewProps = {
    selectedTab: string;
    dashboardData: any;
    scBalance: number;
    getVal: (mapName: string, op: string) => number;
    getDetails: (mapName: string, op: string) => any;
};

export const OperatorDetailsView = ({
    selectedTab, dashboardData, scBalance, getVal, getDetails
}: OperatorDetailsViewProps) => {
    const [expandedDocs, setExpandedDocs] = useState(false);
    const currency = dashboardData.currency;

    return (
        <Box>
            <FundsRoutingGraph
                operatorName={selectedTab}
                escrowBal={getVal('escrow_balance_by_operator', selectedTab)}
                scBalance={scBalance}
                toProducers={getVal('amount_awaited_transfer_from_escrow_to_all_producers', selectedTab)}
                toSC={getVal('amount_awaited_transfer_from_escrow_to_operator', selectedTab)}
                prodToSC={getVal('amount_awaited_transfer_from_producer_to_operator', selectedTab)}
                awaitedRefill={getVal('amount_awaited_to_refill', selectedTab)}
                reqRefill={getVal('amount_awaited_requested_to_refill', selectedTab)}
                awaitedPayout={getVal('amount_awaited_payout_to_operator', selectedTab)}
                currency={currency}
            />

            <StatusLegend />

            <Grid container spacing={4} sx={{ mb: 4 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <EscrowWalletCard 
                        selectedTab={selectedTab} 
                        currency={currency} 
                        getVal={getVal} 
                        getDetails={getDetails} 
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <ScWalletCard 
                        selectedTab={selectedTab} 
                        currency={currency} 
                        getVal={getVal} 
                        getDetails={getDetails} 
                    />
                </Grid>
            </Grid>

            <TransferFlowDocsAccordion 
                expandedDocs={expandedDocs} 
                setExpandedDocs={setExpandedDocs} 
            />
        </Box>
    );
};